module.exports = __webpack_public_path__ + "static/media/edit.cc79f59c.svg";